import React, { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { currentDomain, currentPath } from '../Index';
import { usePromotionsData } from '../data/PromotionData';
import useAppPromotionTheme from '../hooks/useAppPromotionTheme';
import { useNavigate } from 'react-router-dom';
import PromotionSkeletonDetails from '../data/PromotionSkeletonDetails';

export default function ExlusiveVIPRollingCommission({ isLightMode }) {
    const isAppPromo = useAppPromotionTheme(isLightMode);
    const { promotionsData, isPromotionDataReady } = usePromotionsData();
    const data = useMemo(
        () =>
            promotionsData.find(
                (promo) => promo.title === 'Exclusive Rolling Commission'
            ),
        [promotionsData]
    );

    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 841);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Only redirect when promotion data is ready
    // and the promotion genuinely does not exist.
    useEffect(() => {
        if (!isPromotionDataReady) return;

        if (!data) {
            navigate('/not-found', { replace: true });
        }
    }, [isPromotionDataReady, data, navigate]);

    // Show skeleton while waiting for server time.
    if (!isPromotionDataReady) {
        return <PromotionSkeletonDetails />;
    }

    // Avoid displaying incomplete promotion details
    // while redirecting to the not-found page.
    if (!data) {
        return null;
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Exclusive VIP Rolling Commission</title>
                <link rel="icon" href="/images/fav.webp" sizes="32x32" />
                <meta name="description" content="ddd" />
                <link rel="canonical" href={`${currentDomain}${currentPath}`} />
            </Helmet>
            <div className="promotion-page-main all-page-main-container-min-height">
                <div className="promotion-page-container main-container-global-adjusted-padding">
                    <div className="promotion-tnc-page">
                        <div className="promotion-page-breadcrumb">
                            <a
                                href={
                                    isAppPromo
                                        ? '/promotion/'.replace(
                                              '/promotion',
                                              '/app-promotion'
                                          )
                                        : '/promotion/'
                                }
                            >
                                Promotions
                            </a>{' '}
                            / <span>{data.title}</span>
                        </div>
                        <div className="promotion-tnc-banner">
                            <img
                                src={isMobile ? data.imgSrc : data.bannerSrc}
                                alt={`FGH ${data.title}`}
                            />
                        </div>
                        <div className="promotion-tnc-content">
                            <div className="promotion-tnc-info">
                                <div
                                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                                >
                                    {data.promotionMessage.text}
                                </div>
                                <h1>FGH Exclusive VIP Rolling Commission</h1>
                                <h2>
                                    Keep Rolling into Riches with VIP ROLLING
                                    COMMISSION!
                                </h2>
                                <div className="promotion-tnc-period">
                                    <strong>Promo Period: </strong>
                                    <span>Daily Promotion</span>
                                </div>
                            </div>
                            <div className="promotion-tnc-mechanic-content">
                                <strong>Mechanics: </strong>
                                <ol>
                                    <li>
                                        <p>
                                            Play daily in any of our games from
                                            12 NOON to 11:59 AM.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Get your rolling commission next day
                                            based on your daily total bets x
                                            your VIP level %: Alexandrite 0.08%,
                                            Diamond 0.05%, Ruby 0.02%.
                                        </p>
                                        <p>
                                            <span className="promotion-tnc-block-text">
                                                (Example : You are a Alexandrite
                                                VIP LEVEL Total daily bets is
                                                1,000,000 x 0.08% = 800 daily
                                                rolling commission)
                                            </span>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            Bonus will be automatically credited
                                            daily 1-3 PM.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            3x rollover requirement applies to
                                            the rolling commission bonus amount
                                            before any withdrawals.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            We reserve the right to change,
                                            suspend or cancel the promotion at
                                            any time.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <strong className="highlight">
                                                {' '}
                                                Unused Bonus Reset Policy:
                                            </strong>
                                        </p>
                                        <p>
                                            <span className="promotion-tnc-block-text unused-bonus-reset">
                                                &bull; Once the bonus is
                                                credited to the player’s
                                                account, it must be used before{' '}
                                                <strong className="highlight">
                                                    {' '}
                                                    11:00 AM on the first day of
                                                    the following month.{' '}
                                                </strong>{' '}
                                                Any unused bonus balance after
                                                this period will automatically
                                                reset and be forfeited.
                                            </span>
                                        </p>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
